// extracted by mini-css-extract-plugin
var _1 = "OneMillionContainer_wrapper__Z9epD";
export { _1 as "wrapper" }
